import React from 'react';
import { useHistory } from 'react-router-dom';

export const usePreventNavigation = (
  enable: boolean,
  defaultPath: string,
  doNotPreventNavigationDefault?: boolean,
  setLeavingPage?: (value: React.SetStateAction<boolean>) => void,
) => {
  const ref = React.useRef<HTMLDivElement>(null);
  const [showCancellationModal, setShowCancellationModal] =
    React.useState(false);
  const [nextLocation, setNextLocation] = React.useState<{
    pathname: string;
  }>({ pathname: defaultPath });
  const [preventNavigation, setPreventNavigation] = React.useState(
    !doNotPreventNavigationDefault,
  );
  const history = useHistory();

  const onLeave = () => {
    const targetPath = nextLocation?.pathname || defaultPath;
    setNextLocation({ pathname: targetPath });
    setShowCancellationModal(false);
    setPreventNavigation(false);
    history.push(targetPath);
  };

  const onStay = () => {
    setShowCancellationModal(false);
  };

  React.useEffect(() => {
    setLeavingPage?.(!preventNavigation);
    if (!preventNavigation) {
      const targetPath = nextLocation?.pathname || defaultPath;
      const currentFullPath =
        history.location.pathname + history.location.search;
      if (targetPath && targetPath !== currentFullPath) {
        history.push(targetPath);
      }
    }
  }, [history, preventNavigation, setLeavingPage, defaultPath, nextLocation]);

  React.useEffect(() => {
    const onBeforeUnloadHandler = (event: Event): string => {
      setLeavingPage?.(true);
      event.preventDefault();
      event.returnValue = true;
      return '';
    };
    if (enable) {
      window.addEventListener('beforeunload', onBeforeUnloadHandler);

      return () => {
        window.removeEventListener('beforeunload', onBeforeUnloadHandler);
      };
    }
  }, [enable, setLeavingPage]);

  return {
    showCancellationModal,
    preventNavigation,
    setNextLocation,
    onStay,
    onLeave,
    setShowCancellationModal,
    ref,
    setPreventNavigation,
  };
};
